import LandingAbout from 'components/LandingAbout/LandingAbout'

export default LandingAbout
